import { useQuery } from "@tanstack/react-query";
import { SystemNotifications } from "@graylog/server-api";
import { NOTIFICATIONS_QUERY_KEY, BADGE_COUNT_KEY } from "components/notifications/constants";
const POLL_INTERVAL = 3e3;
const NO_SESSION_EXT = { requestShouldExtendSession: false };
const useNotificationBadgeCount = ({ enabled = true } = {}) => {
  const { data, isLoading } = useQuery({
    queryKey: [...NOTIFICATIONS_QUERY_KEY, BADGE_COUNT_KEY],
    queryFn: () => SystemNotifications.getCount(NO_SESSION_EXT),
    refetchInterval: POLL_INTERVAL,
    enabled
  });
  return { data: data != null ? data : 0, isLoading };
};
export default useNotificationBadgeCount;
